import { render } from "./signRecuiter.vue?vue&type=template&id=5387edba&scoped=true"
import script from "./signRecuiter.vue?vue&type=script&lang=js"
export * from "./signRecuiter.vue?vue&type=script&lang=js"

import "./signRecuiter.vue?vue&type=style&index=0&id=5387edba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5387edba"

export default script